import React from "react";

import { EdiStatusInfo } from "../types";
import { formatDisplayDate } from "../../../helpers/dataHelper";
import { formatCurrency } from "../viewerHelpers";

const StatusInfoDisplay: React.FC<{ statusInfo: EdiStatusInfo }> = ({
  statusInfo,
}) => {
  const actionColor =
    statusInfo.actionType === "ACCEPT"
      ? "text-green-600"
      : statusInfo.actionType === "REJECT"
        ? "text-red-600"
        : "text-gray-600";

  return (
    <div className="p-3 bg-white rounded border mb-2">
      <div className="flex items-center justify-between mb-2">
        <span className={`font-medium ${actionColor}`}>
          {statusInfo.actionType || statusInfo.actionCode || "Unknown"}
        </span>
        {statusInfo.effectiveDate && (
          <span className="text-sm text-gray-500">
            {formatDisplayDate(statusInfo.effectiveDate)}
          </span>
        )}
      </div>
      {statusInfo.statusCodeInfos?.map((code, idx) => (
        <div key={idx} className="text-sm border-t border-gray-100 pt-2 mt-2">
          <div
            className="grid gap-2"
            style={{
              gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
            }}
          >
            <div>
              <span className="text-sm text-gray-500">Category</span>
              <div className="font-mono">
                {code.categoryCode} - {code.category}
              </div>
            </div>
            <div>
              <span className="text-sm text-gray-500">Status</span>
              <div className="font-mono">
                {code.statusCode} - {code.status}
              </div>
            </div>
            {code.entity && (
              <div>
                <span className="text-sm text-gray-500">Entity</span>
                <div>
                  {code.entityCode} - {code.entity}
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
      {statusInfo.message && (
        <div className="mt-2 text-sm text-gray-600 italic">
          {statusInfo.message}
        </div>
      )}
      {statusInfo.chargeAmount !== undefined && (
        <div className="mt-2 text-sm">
          <span className="text-gray-500">Charge:</span>{" "}
          {formatCurrency(statusInfo.chargeAmount)}
        </div>
      )}
    </div>
  );
};

export default StatusInfoDisplay;
